import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "妖精电影", to: "/category/电影" },
  { label: "妖精电视剧", to: "/category/电视剧" },
  { label: "精选专题", to: "/special/s1" },
  { label: "关于我们", to: "/about" },
];

const friendLinks = [
  { label: "妖精影视资料库", href: "https://zhinengdianwang.com.cn/fairy-db" },
  { label: "奇幻电影观察", href: "https://zhinengdianwang.com.cn/fantasy-cinema" },
  { label: "精灵文化研究社", href: "https://zhinengdianwang.com.cn/elf-culture" },
  { label: "影视剧情档案馆", href: "https://zhinengdianwang.com.cn/plot-archive" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full bg-primary-950 text-background-100">
      <div className="mx-auto grid w-full max-w-[1200px] grid-cols-1 gap-8 px-4 py-12 md:grid-cols-4 md:px-8 lg:gap-12">
        <div className="md:col-span-2">
          <div className="mb-4 flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
              <i className="ri-sparkling-2-fill text-lg" />
            </span>
            <span className="font-heading text-xl font-bold text-background-50">妖精网站</span>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-background-300">
            妖精网站专注收录妖精主题的电影、电视剧资源，提供丰富的剧情介绍与作品推荐，为喜爱妖精题材影视内容的观众打造便捷、专业的探索门户。
          </p>
          <div className="mt-5 flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-900 text-background-200 transition-colors hover:bg-accent-500 hover:text-primary-950">
              <i className="ri-wechat-line text-lg" />
            </span>
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-900 text-background-200 transition-colors hover:bg-accent-500 hover:text-primary-950">
              <i className="ri-weibo-line text-lg" />
            </span>
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-900 text-background-200 transition-colors hover:bg-accent-500 hover:text-primary-950">
              <i className="ri-mail-line text-lg" />
            </span>
          </div>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-base font-semibold text-background-50">
            <Link to="/">快捷导航</Link>
          </h4>
          <ul className="space-y-2.5">
            {quickLinks.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-sm text-background-300 transition-colors hover:text-accent-400"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-base font-semibold text-background-50">
            <a href="https://zhinengdianwang.com.cn/partners" target="_blank" rel="noopener noreferrer">
              友情链接
            </a>
          </h4>
          <ul className="space-y-2.5">
            {friendLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-background-300 transition-colors hover:text-accent-400"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-900">
        <div className="mx-auto flex w-full max-w-[1200px] flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-background-400 sm:flex-row md:px-8">
          <p>© 2026 妖精网站 FairyFlix · 本站内容均为演示数据，仅供交流学习使用</p>
          <p>妖精题材影视 · 资源整合与剧情介绍门户</p>
        </div>
      </div>
    </footer>
  );
}